'use client';

import {
  Zap,
  Sparkles,
  Shield,
  Tv,
  Download,
  Users,
} from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Lightning Fast',
    description: 'Stream in 4K quality with minimal buffering and seamless playback.',
  },
  {
    icon: Sparkles,
    title: 'Premium Content',
    description: 'Access thousands of movies, shows, and exclusive series.',
  },
  {
    icon: Shield,
    title: 'Secure & Safe',
    description: 'Your privacy is protected with end-to-end encryption.',
  },
  {
    icon: Tv,
    title: 'Multi-Device',
    description: 'Watch on phones, tablets, and smart TVs seamlessly.',
  },
  {
    icon: Download,
    title: 'Offline Download',
    description: 'Download content and watch without internet connection.',
  },
  {
    icon: Users,
    title: 'Family Sharing',
    description: 'Share your account with up to 5 family members.',
  },
];

export function Features() {
  return (
    <section id="features" className="py-20 px-4 bg-card/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why Choose <span className="text-primary">Yessma Originals</span>?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the ultimate streaming platform with cutting-edge features and unmatched quality
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-lg border border-border bg-background hover:border-primary hover:bg-card/80 transition-all group"
              >
                <div className="mb-4 p-3 rounded-lg bg-primary/10 w-fit group-hover:bg-primary/20 transition-colors">
                  <Icon size={24} className="text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-foreground">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
